import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { FlowDefinition } from '../models/flow.model';
import { BaseService } from './base.service';
import { IBaseModel } from '../models/base.model';
import { FlowDefinitionServiceGetParams } from './interfaces/flow-definition.interface';
import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class FlowDefinitionService extends BaseService {
    controllerRoute = 'FlowDefinition';

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    public async getById(id: string, version?: number): Promise<IBaseModel<FlowDefinition>> {
        const url = `${this.apiBaseUrl}/${this.controllerRoute}/${id}/${version || ''}`;
        return await firstValueFrom(this.httpClient.get<IBaseModel<FlowDefinition>>(url));
    }

    public async getByCatalogServiceId(id: string): Promise<IBaseModel<FlowDefinition>> {
        const url = `${this.apiBaseUrl}/${this.controllerRoute}/GetByCatalogServiceId/${id}`;
        return await firstValueFrom(this.httpClient.get<IBaseModel<FlowDefinition>>(url));
    }

    public async filterPaginated(getParams?: FlowDefinitionServiceGetParams): Promise<IBaseModel<FlowDefinition[]>> {
        let httpParams = new HttpParams();

        httpParams = httpParams.append('flowTarget', getParams.flowTarget.toString());
        if (getParams?.locationId != null) httpParams = httpParams.append('locationId', getParams.locationId);
        if (getParams?.page != null) httpParams = httpParams.append('page', getParams.page.toString());
        if (getParams?.pageSize != null) httpParams = httpParams.append('pageSize', getParams.pageSize.toString());
        if (getParams?.sortField != null) httpParams = httpParams.append('sortField', getParams.sortField);
        if (getParams?.isSortDescending != null) httpParams = httpParams.append('isSortDescending', getParams.isSortDescending.toString());
        if (getParams?.skipDataResults != null) httpParams = httpParams.append('skipDataResults', getParams.skipDataResults.toString());
        if (getParams?.searchTokens != null && getParams.searchTokens.length > 0) {
            httpParams = httpParams.append('searchTokens', getParams.searchTokens.map(x => x.trim()).join('◄►'));
        }

        const url = `${this.apiBaseUrl}/${this.controllerRoute}/FilterPaginated`;
        return await firstValueFrom(this.httpClient.get<IBaseModel<FlowDefinition[]>>(url, { params: httpParams }));
    }
}
